module.exports = __webpack_public_path__ + "static/media/20ECE17.40323c95.jpg";